import { VIEWPORT_DIMENSIONS, VISION_CONE_COLOR, VISION_CONE_CONFIG } from "@Components/game/session-results/feedback/visualization/constants";
import { Graphics as PixiGraphics } from "@pixi/graphics";
import { Container, Graphics } from "@pixi/react";
import { useCallback } from "react";

interface VisionConeProps {
  rotation: number;
}

const VisionCone = ({ rotation }: VisionConeProps) => {
  const visionRange = VISION_CONE_CONFIG.RANGE * VIEWPORT_DIMENSIONS.SCALE;
  const leftAngle = -VISION_CONE_CONFIG.ANGLE / 2;
  const rightAngle = VISION_CONE_CONFIG.ANGLE / 2;

  const drawVisionCone = useCallback(
    (g: PixiGraphics) => {
      g.clear();

      const segments = 30;
      for (let i = 0; i < segments; i++) {
        const innerRadius = (visionRange * i) / segments;
        const outerRadius = (visionRange * (i + 1)) / segments;
        const alpha = (0.5 * (segments - i)) / segments;

        g.beginFill(VISION_CONE_COLOR, alpha);
        g.moveTo(outerRadius * Math.cos(leftAngle), outerRadius * Math.sin(leftAngle));
        g.arc(0, 0, outerRadius, leftAngle, rightAngle);
        g.lineTo(innerRadius * Math.cos(rightAngle), innerRadius * Math.sin(rightAngle));
        g.arc(0, 0, innerRadius, rightAngle, leftAngle, true);
        g.closePath();
        g.endFill();
      }
    },
    [leftAngle, rightAngle, visionRange]
  );

  return (
    <Container rotation={Math.PI + rotation}>
      <Graphics draw={drawVisionCone} />
    </Container>
  );
};

export default VisionCone;
